import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ChartLineIcon } from '@phosphor-icons/react'

import { Card } from '@reveni-io/reveni-ui'

import TitlePage from '@/common/components/TitlePage/TitlePage'
import AppContext from '@/common/context/app.context'

import * as Styles from './styles'

const AnalyticsPage = () => {
  const { info } = useContext(AppContext)
  const { t } = useTranslation()

  return (
    <Styles.MainContainer>
      <TitlePage Icon={ChartLineIcon}>{t('Métricas')}</TitlePage>
      <Card>
        <Styles.IframeContainer>
          <iframe title="analytics" src={info?.selectedStore?.analytics_url} />
        </Styles.IframeContainer>
      </Card>
    </Styles.MainContainer>
  )
}

export default AnalyticsPage
